var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextAlignCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.25 13.5c.4142 0 .75.3358.75.75 0 .3796833-.2821653.6934889-.6482323.7431531l-.1017677.0068469h-6.5c-.41421 0-.75-.3358-.75-.75 0-.3796833.28215688-.6934889.64823019-.7431531l.10176981-.0068469zm4-5c.4142 0 .75.33579.75.75s-.3358.75-.75.75h-14.5c-.41421 0-.75-.33579-.75-.75s.33579-.75.75-.75zm-2-5c.4142 0 .75.33579.75.75s-.3358.75-.75.75h-10.5c-.41421 0-.75-.33579-.75-.75s.33579-.75.75-.75z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextAlignCenter);
export default __webpack_public_path__ + "static/media/text-align-center.ec675b17dde48dec28ea328ea091a7f2.svg";
export { ForwardRef as ReactComponent };